<section
  class="tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
  id="legal-info"
>
  <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-1 tw-items-start">
    <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">{{ 'v2.orgSettings.legalInfo.legalInfo' | translate }}</h2>
    <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
      {{ 'v2.orgSettings.legalInfo.description' | translate }}
    </p>
  </div>
  <form [formGroup]="form()" class="tw-flex tw-flex-col">
    @if (!isLoading()) {
    <div>
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-6">
        <basic-input
          [control]="companyName()"
          [label]="'v2.fields.legalName' | translate"
          [icon]="icons.ORG"
          iconType="fill"
          id="legal_name"
          (onKeydown)="onChildKeydown($event)"
          (onBlurValueChange)="onBlur($event)"
        ></basic-input>
        <select-input
          [control]="industrySectorId()"
          [label]="'v2.fields.businessActivity' | translate"
          (valueChanged)="onBusinessActivityChanged($event)"
          key="name"
          [valueName]="'id'"
          [values]="industrySectors()"
          [icon]="icons.BUSINESS_ACTIVITY"
          [maxSelections]="1"
          [basicSelect]="true"
          [enableSearch]="true"
          [isBasicDropdownValue]="true"
          [isCountryField]="false"
          iconType="fill"
          [isSingleSelect]="true"
          id="business_activity_id"
        ></select-input>
        <basic-input
          [control]="licenseNumber()"
          [label]="'v2.fields.licenseNumber' | translate"
          (onKeydown)="onChildKeydown($event)"
          (onBlurValueChange)="onBlur($event)"
          [icon]="icons.LICENSE"
          iconType="fill"
          id="license_number"
        ></basic-input>
        <basic-input
          [control]="taxIdentificationNumber()"
          [label]="'v2.fields.taxId' | translate"
          (onKeydown)="onChildKeydown($event)"
          (onBlurValueChange)="onBlur($event)"
          [icon]="icons.TAX"
          iconType="fill"
          id="tax_id"
        ></basic-input>
        <div class="lg:tw-col-span-2">
          <app-upload
            [fileList]="licensesPermits"
            accept=".jpg, .png, .jpeg, .pdf"
            [maxFileSize]="2 * 1024"
            [maxFilesToUpload]="20"
            [deleteFileWithAPI]="true"
            label="Organization licenses"
            [apiPayload]="{
              organization_id: organizationData()?.id,
              type: uploadTypeEnum.ORGANIZATION
            }"
            (fileChanged)="onPermitsLicenseChanged()"
            (fileDeleted)="onPermitsLicenseChanged()"
          >
          </app-upload>
        </div>
      </div>
    </div>
    } @else {
    <div class="tw-flex tw-flex-col tw-h-[435px] lg:tw-h-[426px]">
      <div class="tw-h-[264px] lg:tw-h-[237px] tw-flex tw-flex-col lg:tw-gap-5 tw-w-full tw-border-gray-200 dark:tw-border-gray-600 tw-py-4 tw-px-7">
        <div class="tw-rounded-xl tw-w-[80px]">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '80px', height: '20px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
        <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-8">
          <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-gap-0">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '320px', height: '58px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden lg:tw-block"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '320px', height: '58px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden lg:tw-block"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="2"
              [theme]="{ width: '258px', height: '36px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-block md:tw-hidden"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="2"
              [theme]="{ width: '632px', height: '36px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden md:tw-block lg:tw-hidden"
            ></ngx-skeleton-loader>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-gap-0">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '320px', height: '58px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden lg:tw-block"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '320px', height: '58px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden lg:tw-block"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="2"
              [theme]="{ width: '258px', height: '36px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-block md:tw-hidden"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="2"
              [theme]="{ width: '632px', height: '36px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
              class="tw-hidden md:tw-block lg:tw-hidden"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-w-full tw-border-gray-200 dark:tw-border-gray-600 tw-border tw-rounded-xl tw-h-[117px]">
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', height: '117px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>
      </div>
    </div>
    }
  </form>
</section>
